import { attachment } from 'ducks/entities/schema'

export const attachmentsGraphQlResponseSchema = {
  attachments: { edges: [{ node: attachment }] },
}
